import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderDashboard from "../../Components/HeaderDashboard";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { flightTransactionReport } from "../../Services/ReservationsApi";

const AllTransactions = () => {
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        pnr: "",
        transactionId: "",
        bookingRefNo: "",
        paymentStatus: "",
        bookingStatus: "",
    });

    const navigate = useNavigate();
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const convertToDate = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    useEffect(() => {
        $("#fromDate").datepicker({
            dateFormat: "dd/mm/yy",
            // changeMonth: true,
            // changeYear: true,
            // maxDate: new Date(),
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    fromDate: dateText,
                }));
            },
        });
    }, []);

    useEffect(() => {
        $("#toDate").datepicker({
            dateFormat: "dd/mm/yy",
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    toDate: dateText,
                }));
            },
        });
    }, []);

    // UPDATE minDate of ToDate WHEN fromDate changes
    useEffect(() => {
        if (filters.fromDate) {
            const minD = convertToDate(filters.fromDate);
            $("#toDate").datepicker("option", "minDate", minD);
        }
    }, [filters.fromDate]);

    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                GDSPNR: filters.pnr,
                TrackID: filters.transactionId,
                ReferenceNo: filters.bookingRefNo,
                PaymentStatus: filters.paymentStatus,
                BookingStatus: filters.bookingStatus,
                UserName: "",
            };

            const data = await flightTransactionReport(requestBody);

            const all = data?.allTransactions;
            const list = data?.allTransactions?.airTransactionResponse || [];
            setTransactions(list);

            setSummary({
                paymentSuccessCount: all?.paymentSuccessCount || 0,
                paymentRequestedCount: all?.paymentRequestedCount || 0,
                paymentFailedCount: all?.paymentFailedCount || 0,
                bookingSuccessCount: all?.bookingSuccessCount || 0,
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <HeaderDashboard />

            <div className="toolbar py-2" id="kt_toolbar">
                <div className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="page-title d-flex align-items-center flex-wrap">
                            <h1 className="text-gray-900 fw-bold fs-3">Reservations</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Flight</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>

                                <li class="breadcrumb-item text-gray-900">All Transactions</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filters */}
            <section className="wraper">
                <div className="box_shadow mt-14">
                    <div className="row">
                        <div className="col-md-3 mb-3">
                            <label>From Date</label>
                            <input type="text" id="fromDate" className="form-control" placeholder="From Date" readOnly />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label>To Date</label>
                            <input type="text" id="toDate" className="form-control" placeholder="To Date" readOnly />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label>PNR Number</label>
                            <input
                                className="form-control form-control-solid"
                                type="text"
                                name="pnr"
                                value={filters.pnr}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Transaction ID */}
                        <div className="col-md-3 mb-3">
                            <label>Transaction ID</label>
                            <input
                                className="form-control form-control-solid"
                                type="text"
                                name="transactionId"
                                value={filters.transactionId}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Booking RefNo */}
                        <div className="col-md-3 mb-3">
                            <label>Booking RefNo</label>
                            <input
                                className="form-control form-control-solid"
                                type="text"
                                name="bookingRefNo"
                                value={filters.bookingRefNo}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Payment Status */}
                        <div className="col-md-3 mb-3">
                            <label>Payment Status</label>
                            <select
                                className="form-select form-select-solid"
                                name="paymentStatus"
                                value={filters.paymentStatus}
                                onChange={handleChange}
                            >
                                <option value="">- Select -</option>
                                <option value="Success">Success</option>
                                <option value="Requested">Requested</option>
                                <option value="Failure">Failure</option>
                                <option value="Refunded">Refunded</option>
                                <option value="UnPaid">UnPaid</option>
                            </select>
                        </div>

                        {/* Booking Status */}
                        <div className="col-md-3 mb-3">
                            <label>Booking Status</label>
                            <select
                                className="form-select form-select-solid"
                                name="bookingStatus"
                                value={filters.bookingStatus}
                                onChange={handleChange}
                            >
                                <option value="">- Select -</option>
                                <option value="Confirmed">Confirmed</option>
                                <option value="Hold">Hold</option>
                                <option value="Failure">Failure</option>
                                <option value="Released">Released</option>
                                <option value="OnRequest">OnRequest</option>
                                <option value="Cancelled">Cancelled</option>
                                <option value="Voided">Voided</option>
                            </select>
                        </div>

                        {/* Search Button */}
                        <div className="col-md-3 mb-3">
                            <button
                                type="button"
                                className="btn btn-primary mt-7"
                                onClick={handleSearch}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Search"}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="box_shadow mt-3">
                    <div className="table-responsive">
                        <table className="table table-striped align-middle">
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th className="ps-4">Sr No</th>
                                    <th>RefNo.</th>
                                    <th>Payment Status</th>
                                    <th>Booking Status</th>
                                    <th>PNR</th>
                                    <th>Ticketing Status</th>
                                    <th>Booking Date</th>
                                    <th>Amount</th>
                                    <th>Sector</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {transactions.length > 0 ? (
                                    transactions.map((item, index) => (
                                        <tr key={index}>
                                            <td className="ps-4">{index + 1}</td>
                                            <td>{item.referenceNo}</td>
                                            <td>{item.paymentStatus}</td>
                                            <td>{item.bookingStatus}</td>
                                            <td>{item.gDSPNR || "-"}</td>
                                            <td>{item.ticketingStatus}</td>
                                            <td>{item.insertedOn}</td>
                                            <td><i className="fa fa-inr"></i> {item.totalFare}</td>
                                            <td>{item.sector}</td>
                                            <td className="text-center">
                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() =>
                                                        navigate(
                                                            `/Reservations/Flight/TransactionDetails?referenceNo=${item.referenceNo}`
                                                        )
                                                    }
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="text-center text-muted">
                                            {loading ? "Loading..." : "No records found"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AllTransactions;
